export type MusicReleaseType = "album" | "ep" | "single" | "compilation" | "live" | "demo" | "mixtape";

export interface MusicTrack {
  id: string;
  releaseId: string;
  trackNumber: number;
  title: string;
  durationSeconds: number | null;
  audioUrl: string | null;
  previewEmbedUrl: string | null;
}

export interface MusicTrackRequest {
  trackNumber?: number | null;
  title: string;
  durationSeconds?: number | null;
  audioUrl?: string | null;
  previewEmbedUrl?: string | null;
}

export interface MusicRelease {
  id: string;
  title: string;
  slug: string;
  type: MusicReleaseType;
  releaseDate: string | null;
  coverImageUrl: string | null;
  description: string | null;
  embedUrl: string | null;
  streamingLinks: Record<string, string>;
  published: boolean;
  tracks: MusicTrack[];
}

export interface MusicReleaseRequest {
  title: string;
  slug?: string | null;
  type: MusicReleaseType;
  releaseDate?: string | null;
  coverImageUrl?: string | null;
  description?: string | null;
  embedUrl?: string | null;
  streamingLinks?: Record<string, string>;
  published?: boolean;
  tracks?: MusicTrackRequest[];
}

export const MUSIC_RELEASE_TYPE_LABELS: Record<MusicReleaseType, string> = {
  album: "Album",
  ep: "EP",
  single: "Single",
  compilation: "Compilation",
  live: "Live",
  demo: "Demo",
  mixtape: "Mixtape",
};
